import React, { useState, useEffect } from 'react';
import './WarehousesPage.css';
import WarehousesHeader from './WarehousesHeader';
import WarehouseGrid from './WarehouseGrid';
import AddWarehouseModal from './AddWarehouseModal';
import EditWarehouseModal from './EditWarehouseModal';
import WarehouseDetailsPanel from '../../../components/shared/WarehouseDetailsPanel/WarehouseDetailsPanel';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import cacheStorage from '../../../utils/cacheStorage';

export default function WarehousesPage() {
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [warehouseToEdit, setWarehouseToEdit] = useState(null);
  const [selectedWarehouseDetails, setSelectedWarehouseDetails] = useState(null);

  useEffect(() => {
    if (searchQuery && warehouses.length > 0) {
      const match = warehouses.find(w => w.id === searchQuery);
      if (match) {
        setSelectedWarehouseDetails(match);
      }
    }
  }, [searchQuery, warehouses]);

  const fetchWarehouses = async () => {
    try {
      setLoading(true);
      const token = cacheStorage.getItem('access_token');

      const response = await axios.get('https://smart-cargo-backend-923182991420.us-central1.run.app/api/warehouses', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Map DB fields to UI expected structure
      const mappedData = response.data.map(w => ({
        id: `WH10${w.id}`, // Optional: Formatting ID for UI
        name: w.name,
        location: w.address,
        capacity: "N/A",
        currentStock: "N/A",
        percentage: 0,
        coordinates: { lat: w.location_x, lng: w.location_y }
      }));

      setWarehouses(mappedData);
      setError(null);
    } catch (err) {
      console.error("Error fetching warehouses:", err);
      setError("Unable to load warehouse data. The service may be unavailable.");
      setWarehouses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const handleAddWarehouse = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleAddSuccess = () => {
    fetchWarehouses();
    handleModalClose();
  };


  const handleEditClick = (warehouse) => {
    setWarehouseToEdit(warehouse);
    setIsEditModalOpen(true);
  };
  const handleEditSuccess = (updatedWarehouse) => {
    setWarehouses(prev => prev.map(w => w.id === updatedWarehouse.id ? updatedWarehouse : w));
  };

  const filteredWarehouses = warehouses.filter(warehouse => {
    const query = searchQuery.toLowerCase();
    return (
        (warehouse.id && warehouse.id.toLowerCase().includes(query)) ||
        (warehouse.location && warehouse.location.toLowerCase().includes(query)) ||
        (warehouse.name && warehouse.name.toLowerCase().includes(query)) ||
        (warehouse.capacity && warehouse.capacity.toString().includes(query))
    );
  });

  return (
      <div className="warehouses-page">
        <WarehousesHeader
            onAdd={handleAddWarehouse}
        />

        {loading ? (
            <div className="warehouses-loading">Loading warehouses...</div>
        ) : error ? (
            <div className="warehouses-error-state">
              <h3>Information Unavailable</h3>
              <p>{error}</p>
              <div className="warehouse-grid-empty">
                No warehouses to display at this time.
              </div>
            </div>
        ) : (
            <WarehouseGrid warehouses={filteredWarehouses} onEdit={handleEditClick} onWarehouseClick={setSelectedWarehouseDetails} />
        )}

        <AddWarehouseModal isOpen={isModalOpen} onClose={handleModalClose} onAddSuccess={handleAddSuccess} />
        <EditWarehouseModal isOpen={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} warehouseData={warehouseToEdit} onEditSuccess={handleEditSuccess} />
        <WarehouseDetailsPanel
            isOpen={!!selectedWarehouseDetails}
            onClose={() => setSelectedWarehouseDetails(null)}
            warehouseData={selectedWarehouseDetails}
            onEdit={(data) => {
              setSelectedWarehouseDetails(null);
              handleEditClick(data);
            }}
        />
      </div>
  );
}